import type { CountriesResponse } from "@features/countries/types";

import { api } from "@services/api";
import { decryptData, encryptData } from "@shared/utils/encryption";

export class CountriesService {
  private readonly basePath = "/public/countries";

  // Get countries method
  public async getCountries(force = false): Promise<CountriesResponse> {
    const countries = localStorage.getItem("countries");

    if (!force && countries) return JSON.parse(countries);

    const response = await api.post<{ data: string }>(`${this.basePath}`, {
      data: await encryptData({}),
    });

    const decryptedData = await decryptData<CountriesResponse>(response.data);

    localStorage.setItem("countries", JSON.stringify(decryptedData));

    return decryptedData;
  }
}

export const countriesService = new CountriesService();
